import { KResource } from '@envclient/envengine/src/envs/koenigsburg/KResource';
import React from 'react';
import classes from './KResourceItem.module.scss';
import { colorMap } from '../ccson/CcsonPlayerItem';
import { CSSPos } from '../../types/frontendTypes';

type Props = {
  resource: KResource;
  pos?: CSSPos;
  onClick?: (resource: KResource) => void;
  selected?: boolean;
};

type PointerEvent = 'auto' | 'none';

export const KResourceItem = (props: Props) => {
  const { resource, pos, onClick, selected } = props;
  const { value, color, score, harvested } = resource;
  //const [moved, setMoved] = React.useState(false);

  const finalStyle = { ...pos, pointerEvents: (onClick ? 'auto' : 'none') as PointerEvent };

  const colorCode = colorMap[color].code;

  const borderColor = selected ? '#f00' : resource.moved ? 'orange' : colorCode;

  const handleClick = () => {
    if (onClick) {
      onClick(resource);
      //setMoved(true);
    }
  };

  return (
    <div className={classes.resource} style={finalStyle} onClick={handleClick}>
      <svg width="41" height="50">
        <rect
          x="0"
          y="0"
          width="41"
          height="50"
          fill={colorCode}
          style={{ opacity: harvested ? 0.5 : 1 }}
          stroke={borderColor}
          strokeWidth={selected || resource.moved ? 8 : 0}
        />
        <text x="20.5" y="25" textAnchor="middle" fill="#000" fontSize="22" dy=".3em" style={{ pointerEvents: 'none' }}>
          {score > 0 ? score : value}
        </text>
      </svg>
    </div>
  );
};
